export default "__VITE_ASSET__c7ba2303__"